import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Contact.module.scss";
export type ContactInfoProps = {
  title: string;
  description: string;
  email: string;
  phone: string;
};
export const ContactInfo: React.FC<ContactInfoProps> = t0 => {
  const $ = _c(15);
  const {
    title,
    description,
    email,
    phone
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3>{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <p className="inngress">{description}</p>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== email) {
    t3 = <div>{email}</div>;
    $[4] = email;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== phone) {
    t4 = <div>{phone}</div>;
    $[6] = phone;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className={styles.channels}>{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t5) {
    t6 = <div className={styles.container}>{t1}{t2}{t5}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};